"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryFuturesIndexOnce = exports.useFuturesIndex = exports.useFuturesIndexs = exports.refreshFuturesIndexs = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const FutureAPI_1 = require("../../apis/FutureAPI");
const react_1 = require("react");
const SymbolCounter = new Map();
const getCurrentRegisterSymbols = () => {
    const symbols = new Set(SymbolCounter.keys());
    return [...symbols];
};
const registerSymbols = (symbols) => {
    let hasNew = false;
    symbols.forEach((e) => {
        var _a;
        // 已经存在的计数
        const oldCount = (_a = SymbolCounter.get(e)) !== null && _a !== void 0 ? _a : 0;
        if (oldCount === 0) {
            hasNew = true;
        }
        // 增加值
        SymbolCounter.set(e, oldCount + 1);
    });
    return hasNew;
};
const unregisterSymbols = (symbols) => {
    symbols.forEach((e) => {
        var _a;
        // 已经存在的计数
        const oldCount = (_a = SymbolCounter.get(e)) !== null && _a !== void 0 ? _a : 0;
        if (oldCount <= 0) {
            throw "FutureIndexProvider SymbolCounter error: " + `${e} count is ${oldCount}, can not minus`;
        }
        const newCount = oldCount - 1;
        if (newCount <= 0) {
            SymbolCounter.delete(e);
        }
        else {
            SymbolCounter.set(e, newCount);
        }
    });
};
const triggerSubject = new rxjs_1.Subject();
const ob$ = (0, rxjs_1.merge)((0, rxjs_1.timer)(0, 5000), triggerSubject).pipe((0, operators_1.switchMap)(() => {
    const symbols = getCurrentRegisterSymbols();
    if (!symbols.length) {
        return (0, rxjs_1.of)(new Array());
    }
    let retryCountForECONNABORTED = 0;
    return (0, FutureAPI_1.getFutureMarketIndexes)(symbols).pipe((0, operators_1.retryWhen)((errors) => errors.pipe((0, operators_1.delayWhen)((error) => {
        if ((error === null || error === void 0 ? void 0 : error.code) === "ECONNABORTED") {
            if (retryCountForECONNABORTED > 0) {
                throw error;
            }
            retryCountForECONNABORTED++;
            return (0, rxjs_1.timer)(600);
        }
        throw error;
    }))), (0, operators_1.catchError)((err) => {
        console.error(`FutureIndexProvider error => ${typeof err === "string" ? err : JSON.stringify(err)}`);
        if (err.code === "ECONNABORTED") {
            return rxjs_1.NEVER;
        }
        return (0, rxjs_1.of)(new Array());
    }));
}), (0, operators_1.publishBehavior)(new Array()), (0, operators_1.refCount)());
const registerFutureIndexOb = (symbols) => {
    return new rxjs_1.Observable((sub) => {
        const symbolSet = new Set(symbols);
        const hasNew = registerSymbols(symbols);
        if (hasNew) {
            (0, exports.refreshFuturesIndexs)();
        }
        const unsub = ob$.subscribe({
            next: (data) => {
                const filterData = data.filter((e) => symbolSet.has(e.symbol));
                if (filterData.length) {
                    sub.next(filterData);
                }
            },
            error: () => {
                try {
                    unregisterSymbols(symbols);
                }
                catch (error) {
                    sub.error(error);
                }
            },
            complete: () => {
                try {
                    unregisterSymbols(symbols);
                }
                catch (error) {
                    sub.error(error);
                }
            },
        });
        return () => {
            try {
                unregisterSymbols(symbols);
            }
            catch (error) {
                console.error(error);
            }
            unsub.unsubscribe();
        };
    });
};
const refreshFuturesIndexs = () => {
    triggerSubject.next(new Date().getTime());
};
exports.refreshFuturesIndexs = refreshFuturesIndexs;
const useFuturesIndexs = (symbols, isActive) => {
    const [indexs, setIndex] = (0, react_1.useState)();
    const symbolsStr = (0, react_1.useMemo)(() => {
        return symbols.join("_");
    }, [symbols]);
    (0, react_1.useEffect)(() => {
        if (!isActive) {
            return;
        }
        const sub = registerFutureIndexOb(symbols).subscribe({
            next: (value) => {
                setIndex(value);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isActive, symbolsStr]);
    return indexs;
};
exports.useFuturesIndexs = useFuturesIndexs;
const useFuturesIndex = (symbol, isActive) => {
    const indexs = (0, exports.useFuturesIndexs)([symbol], isActive);
    return (indexs === null || indexs === void 0 ? void 0 : indexs.length) ? indexs[0] : undefined;
};
exports.useFuturesIndex = useFuturesIndex;
const queryFuturesIndexOnce = (symbol) => {
    return registerFutureIndexOb([symbol]).pipe((0, operators_1.take)(1), (0, operators_1.map)((res) => {
        if (res === null || res === void 0 ? void 0 : res.length) {
            return res[0];
        }
        else {
            throw { code: -1, message: "no indexs" };
        }
    }));
};
exports.queryFuturesIndexOnce = queryFuturesIndexOnce;
